import { IContractHttpParams } from '@core/interfaces/api.interface';
import {
	AllowedDetailsTabEnum,
	ProductEnum
}                              from '@core/interfaces/common.interfaces';
import {
	RouteBaseDefinition,
	RouteBasePath
}                              from '@core/interfaces/route.interface';

export enum ContractRoutesEnum {
	ListPage = '',
	ListPageProduct = ':product',
	DetailPage = ':product/:contractId',
	DetailPageTab = ':product/:contractId/:tab',
	FormPageCreate = ':product/create',
	FormPageUpdate = ':product/:contractId/update',
	UsagePage = ':contractId/usage/:product/:usagePeriod'
}

export enum AllowedDetailPageChildRoutes {
	ChangeLog = ':product/:contractId/changelog'
}

export interface ContractListPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Contracts;

	path: ContractRoutesEnum.ListPage;

	queryParams?: IContractHttpParams;
}

export interface ContractListPageProductRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Contracts;

	path: ContractRoutesEnum.ListPageProduct;

	queryParams?: IContractHttpParams;

	params: { product: ProductEnum };

	replaceLastStoredRouteWithNew: boolean;
}

export interface ContractDetailPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Contracts;

	path: ContractRoutesEnum.DetailPage;

	params: {
		contractId: string,
		product: ProductEnum
	};
}

export interface ContractDetailPageTabRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Contracts;

	path: ContractRoutesEnum.DetailPageTab;

	params: {
		contractId: string,
		product: ProductEnum,
		tab: AllowedDetailsTabEnum
	};

	replaceLastStoredRouteWithNew: boolean;
}

export interface ContractFormPageCreateRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Contracts;

	path: ContractRoutesEnum.FormPageCreate;

	params: { product: ProductEnum };
}

export interface ContractFormPageUpdateRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Contracts;

	path: ContractRoutesEnum.FormPageUpdate;

	params: {
		contractId: string,
		product: ProductEnum
	};
}

export interface ContractUsagePageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Contracts;
	path: ContractRoutesEnum.UsagePage;
	params: {
		product: ProductEnum,
		contractId: string,
		usagePeriod: string
	};
}
